import { Component, forwardRef, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseDropdownComponent }                from '../../baseclasses/BaseDropdown.component';

@Component({
  selector: 'my-equipmentgraphics-dropdown',
  templateUrl: './EquipmentGraphicsDropdown.component.html',
  providers: [{provide: BaseDropdownComponent, useExisting: forwardRef(() => EquipmentGraphicsDropdownComponent)}]
})
export class EquipmentGraphicsDropdownComponent extends BaseDropdownComponent {

    filter: filters.EquipmentGraphicsFilter;
    constructor(private domainDataService: serv.DomainDataService) 
    { 
        super();
        this.filter = new filters.EquipmentGraphicsFilter();
    }


    ngOnInit(): void {
    }

    public load(){
        this.domainDataService.getEquipmentGraphics(this.filter).subscribe(x=> this.onGetEquipmentGraphicsDone(x));
        
    }

    public loadOnDemand(){
        this.domainDataService.getEquipmentGraphics(this.filter).subscribe(x=> this.onGetEquipmentGraphicsDone(x));
    }
    
    onGetEquipmentGraphicsDone(items: ent.EquipmentGraphics[]){
        this.selectItems = [];
        this.selectItems.push({label:"", value:Constants._NONE});
        items.forEach(y=> this.selectItems.push({label:y.FullName, value:y.ID}));
        if (this.selectedID){
            this.value = this.selectedID;
        }
    }

}